import type { interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { CommentDialogService, CommentDialogServiceImpl } from './service/comment-dialog.service';

export const commentDialogModule = (bind: interfaces.Bind) => {
    bind(CommentDialogService).to(CommentDialogServiceImpl);
};
